
export const commonEnvironment = {
  production: false,
  host: 'https://6hw4yib914.execute-api.us-east-1.amazonaws.com/desa',
  mock: false,
  hostMock:'http://localhost:6969',
  proxy:false,
  captcha: '6LdAvNEcAAAAANqLEoa_4ynWJGoXbBY5VsH6D33H',
  apiKey:'Ea0d3R4l2l2pa4iVaPtnC6UjuwWWGgjS360vKHbd',
  enableInConstruction:false,
  savingsAccountsGeneralConditions: 'https://pacinet-prod.s3.amazonaws.com/static/CuentasAhorros/Contrato-Condiciones-Generales-CCG001.pdf',
  termsAndConditions: 'https://pacinet-prod.s3.amazonaws.com/static/CuentasAhorros/PacinetMovil_Terminos-y-Condiciones.pdf',
  CTSGeneralConditions: 'https://pacinet-prod.s3.amazonaws.com/static/aperturaCTS/Contrato-Condiciones-Generales-CCG001-T1.pdf',
  CTSContract: 'https://pacinet-prod.s3.amazonaws.com/static/aperturaCTS/Contrato-CTS-T1.pdf',
  CTSTransferFormatDeposit: 'https://pacinet-prod.s3.amazonaws.com/static/aperturaCTS/Formato-traslado-deposito-CTS.pdf',
  CTSTermsAndConditions: 'https://pacinet-prod.s3.amazonaws.com/static/aperturaCTS/PacinetMovil_Terminos-y-Condiciones-T1.pdf',
  GTM_ID: 'GTM-KKH2ZW6' //desa
};
